import Keyb from "keyb"
import Joyp from "joyp"
import Screenfull from "screenfull"
import Resize from "@frog/source/utility/Resize.js"

import Game from "@frog/source/models/Game.js"
import Director from "@frog/source/juice/Director.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/admin/Navigation.js"
import Dev from "@frog/source/models/admin/Dev.js"
import Step from "@frog/source/juice/Step.js"

import Stage from "@frog/source/models/Stage.js"
import Unit from "@frog/source/models/Unit.js"
import skills from "@frog/source/data/skills.js"

export default new class App {
    constructor() {
        window.frog = window.frog || {}
        window.frog.app = this

        this.tutorial = {}
    }
    update(delta) {
        if(Keyb.isPressed("<control>")
        && Keyb.isPressed("Q")) {
            Navigation.go("/title")
        }

        if(Keyb.isPressed("<shift>")
        && Keyb.wasJustPressed("F")) {
            Screenfull.toggle()
        }

        if(Navigation.state.screen == "ChapterScreen") {
            if(Dev.inProtoMode == true) {
                Navigation.state.escape = undefined
            }
            if(Dev.inProtoMode == false
            && Keyb.wasJustPressed("<escape>", delta.ms)) {
                if(Navigation.state.escape == undefined) {
                    Navigation.state.escape = {"section": "MainSection"}
                } else if(Navigation.state.escape != undefined) {
                    if(Navigation.state.escape.section == "MainSection") {
                        Navigation.state.escape = undefined
                    } else if(Navigation.state.escape.section == "OptionsSection") {
                        Navigation.state.escape.section = "MainSection"
                    }
                }
            }

            if(Navigation.state != undefined
            && Navigation.state.escape != undefined) {
                return // paused!!
            }
        }

        if(this.game != undefined) {
            Game.update(this.game, delta)
        }
    }
    load(app) {
        this.game = Game.load(app.game)
    }
    getActiveStage() {
        if(this.game != undefined
        && this.game.chapter != undefined
        && this.game.chapter.sequence != undefined
        && this.game.chapter.sequence.steps != undefined
        && this.game.chapter.sequence.steps[0] != undefined
        && this.game.chapter.sequence.steps[0].stage != undefined) {
            return this.game.chapter.sequence.steps[0].stage
        }
        if(this.game != undefined
        && this.game.chapter != undefined
        && this.game.chapter.sequence != undefined
        && this.game.chapter.sequence.steps != undefined
        && this.game.chapter.sequence.steps[0] != undefined
        && this.game.chapter.sequence.steps[0].omegastage != undefined) {
            return this.game.chapter.sequence.steps[0].omegastage
        }
        if(this.game != undefined
        && this.game.chapter != undefined) {
            return this.game.chapter.stage
        }
    }
}
